import { GETUSER, GETUSERDETAIL, GET_DEPARTMENT_WISE_USER, GET_USER_DATA_BY_EMAIL_COMPANY, GET_USER_DATA_REQUEST, GET_USER_DETAILS_BY_EMAIL, RESET_REDUX_STATE, GET_COMPANY_NAMES, GET_USER_DEPARTMENTS, GET_COLLABORATOR_BY_TYPE, GET_COLLABORATOR_BY_COMPANY, GET_ALL_USER_TYPES_INFO } from "../constants";

const initState = {
  userList: [],
  userDetail: {},
  department_wise_user: [],
  userData: [],
  userDetails: {},
  embeddedUserData: "",
  companyNames: [],
  userDepartments: [],
  collaboratorList: [],
  collaboratorListByCompany: [],
  allusertypesinfo:[]
};

const user = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GETUSER: {
      return {
        ...state,
        userList: payload,
      };
    }
    case GETUSERDETAIL: {
      return {
        ...state,
        userDetail: payload,
      };
    }

    case GET_DEPARTMENT_WISE_USER: {
        return {
            ...state,
            department_wise_user: payload
        }
    }

    case GET_USER_DATA_REQUEST: {
      return {
        ...state,
        userData: payload
      }
    }

    case GET_USER_DETAILS_BY_EMAIL: {
      return {
        ...state,
        userDetails: payload
      }
    }

    case GET_USER_DATA_BY_EMAIL_COMPANY: {
      return {
        ...state,
        embeddedUserData: payload
      }
    }

    case GET_COMPANY_NAMES: {
      return {
        ...state,
        companyNames: payload
      }
    }

    case GET_USER_DEPARTMENTS: {
      return {
        ...state,
        userDepartments: payload
      }
    }

    case GET_COLLABORATOR_BY_TYPE: {
      return {
        ...state,
        collaboratorList: payload
      }
    }
    case GET_COLLABORATOR_BY_COMPANY: {
      return {
        ...state,
        collaboratorListByCompany: payload
      }
    }
    case RESET_REDUX_STATE: {
      return initState
    }

    case GET_ALL_USER_TYPES_INFO : {
      return {
        ...state,
        allusertypesinfo : payload
      }
    }

    default:
      return state;
  }
};

export default user;
